import React, { useRef, useState, useCallback } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import MusicianGraph from './components/musicianGrapher';
import SelectionMenu from './components/selectionMenu';
import BlurVignette from './components/blurVignette';
import ShareImagesMenu from './components/shareImagesMenu.jsx';
import HelpMenu from './components/helpMenu.jsx';
import MobileZoomControls from './components/mobileZoomControls.jsx';
import AnimatedGradientBackground from './components/animatedGradientBackground';
import SEO from './components/seo.jsx';
import './App.css';

function App() {
  const backgroundRef = useRef();
  const [username, setUsername] = useState('');
  const [initialMusicians, setInitialMusicians] = useState([]);
  const [isMenuVisible, setIsMenuVisible] = useState(true);
  const [downloadGraph, setDownloadGraph] = useState(null);
  const [mobileZoomLevel, setMobileZoomLevel] = useState(1);
  const [mobileZoomHandlers, setMobileZoomHandlers] = useState({ onZoomIn: null, onZoomOut: null });

  const handleDownloadRequest = (downloadFn) => {
    setDownloadGraph(() => downloadFn);
  };

  const handleMobileZoomRequest = useCallback((zoomLevel, handlers) => {
    setMobileZoomLevel(zoomLevel);
    setMobileZoomHandlers(handlers);
  }, []);

  const handleMusiciansUpdate = (musicians) => {
    setInitialMusicians(musicians);
    setIsMenuVisible(false);
  };

  const handleMouseMove = (event) => {
    backgroundRef.current?.handleMouseMove(event);
  };

  const handleZoomTransform = (x, y, scale) => {
    backgroundRef.current?.setZoomTransform(x, y, scale);
  };

  const handleGraphActivity = (active) => {
    backgroundRef.current?.setPaused(active);
  };

  const getSEOProps = () => {
    if (username && !isMenuVisible) {
      return {
        title: `${username}'s Music Network - Musician Grapher`,
        username: username
      };
    }
    return {};
  };

  return (
    <HelmetProvider>
      <SEO {...getSEOProps()} />
      <AnimatedGradientBackground ref={backgroundRef} />
      <BlurVignette />
      <SelectionMenu
        setInitialMusicians={handleMusiciansUpdate}
        setUsername={setUsername}
        isVisible={isMenuVisible}
      />
      <ShareImagesMenu isVisible={!isMenuVisible} onDownload={downloadGraph} />
      <HelpMenu isVisible={!isMenuVisible} />
      <MobileZoomControls
        isVisible={!isMenuVisible}
        mobileZoomLevel={mobileZoomLevel}
        onZoomIn={mobileZoomHandlers.onZoomIn}
        onZoomOut={mobileZoomHandlers.onZoomOut}
      />
      <MusicianGraph
        initialMusicians={initialMusicians}
        onMouseMove={handleMouseMove}
        onZoomTransform={handleZoomTransform}
        onActivityChange={handleGraphActivity}
        onDownloadRequest={handleDownloadRequest}
        onMobileZoomRequest={handleMobileZoomRequest}
        username={username}
      />
    </HelmetProvider>
  );
}

export default App;
